<template>
  <div @click="sendStatistic" class="ad-car-block" :class="{fixed:fixedBlock,fixed_bottom:fixedBottom}"
       :style="styleBlock">
    <div v-if="getIframe" v-html="getIframe"></div>
    <div v-if="ad && getImage">
      <div v-if="!ad.link">
        <img :src="getImage"/>
      </div>

      <a v-else :href="ad.link" target="_blank">
        <img :src="getImage"/>
      </a>
    </div>
  </div>
</template>

<script>
import getBaseUrl from "@/helpers/getBaseUrl";
import ad from "@/mixins/ad"
import {mapActions} from "vuex";

export default {
  data: () => ({
    fixedBlock: false,
    fixedBottom: false,
    styleBlock: {},
    bannerHeight: null
  }),
  props: {
    ad: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mixins:[ad],
  methods: {
    ...mapActions({
      adStatistic: 'ad/SEND_STATISTIC'
    }),
    sendStatistic() {
      this.adStatistic({id: this.ad.id});
    },
    scrollAd() {
      if (!this.isMobile) {
        let sliderElement = document.querySelector(".index-slider");
        let bannerElement = document.querySelector(".main-description-wrap");

        if(!sliderElement || !bannerElement){
          return;
        }

        if(!this.bannerHeight){
          this.bannerHeight = document.querySelector(".ad-car-block").clientHeight;
        }

        let sliderPos = sliderElement.getBoundingClientRect().top - (this.bannerHeight + 160);
        let bannerPos = bannerElement.getBoundingClientRect().top - 50;
        if (bannerPos < 0) {
          this.fixedBlock = true;
        } else {
          this.fixedBlock = false;
          this.styleBlock = {};
        }

        if (sliderPos < 0) {
          this.fixedBlock = false;
          this.fixedBottom = true;
          //{top: (sliderElement.offsetTop - (510 - 80)) + 'px'};//
          this.styleBlock = {top: (sliderElement.offsetTop - (sliderElement.clientHeight) - 80) + 'px'}
        } else {
          //this.fixedBlock = true;
          this.fixedBottom = false;
          this.styleBlock = {top: '80px'}
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.$device.mobile();
    },
    getImage() {
      if (!this.ad.img_mobile || !this.ad.img_desktop) {
        return false;
      }
      return getBaseUrl() + '/img/rec/' + (this.isMobile ? this.ad.img_mobile : this.ad.img_desktop);
    }
  },
  mounted() {
      window.addEventListener("scroll", this.scrollAd);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollAd);
  },
}
</script>

<style lang="less" scoped>

</style>